export const CREATE_COMPANY_SELECT_TYPE = 'importist/company/CREATE_COMPANY_SELECT_TYPE';
